/* eslint-disable prefer-arrow/prefer-arrow-functions */

import React from 'react';

function LeftSidePage() {
  return <img src="assets/images/travelB2b.jpg" alt="travel" style={{ width: '100%' }} />;
}

export default LeftSidePage;
